import { RESULT_BACKGROUNDS, RESULT_RATIOS } from "../resultAssets";
import { TEXT_STYLES } from "../resultTheme";
import {
    COMMON_NIGHT_ZONES,
    DEFAULT_POST_TYPOGRAPHY,
    MC_DAY_ZONES,
    createStandardLayout, NIGHT_A_GROUP,
} from "./sharedLayouts";

const MC_DAY_POST_AREA = {
    frame: { left: 12, width: 33.5 },
    rows: {
        startTop: 25.2,
        rowHeight: 6.65,
    },
};

const MC_NIGHT_POST_AREA = {
    frame: { left: 12, width: 33.5 },
    rows: {
        startTop: 45.5,
        rowHeight: 8.5,
    },
};

const DAY_LO_LAYOUT = {
    rowGap: "1.7%",
    columnGap: "3%",
    columns: 2,
};


const NIGHT_LO_LAYOUT = {
    rowGap: "1.2%",
    columnGap: "3%",
    columns: 2,
};

export const mcConfig = {
    bg: RESULT_BACKGROUNDS.MC,
    layout: {
        DAY: createStandardLayout({
            ratio: RESULT_RATIOS.MC.DAY,
            zones: MC_DAY_ZONES,
            postArea: MC_DAY_POST_AREA,
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: DAY_LO_LAYOUT,
            textStyle: TEXT_STYLES.mc,
        }),
        NIGHT: createStandardLayout({
            ratio: RESULT_RATIOS.MC.NIGHT,
            zones: COMMON_NIGHT_ZONES,
            postArea: MC_NIGHT_POST_AREA,
            postTypography: DEFAULT_POST_TYPOGRAPHY,
            loLayout: NIGHT_LO_LAYOUT,
            aGroup: NIGHT_A_GROUP,
            textStyle: TEXT_STYLES.mc,
        }),
    },
};
